import TextField from '@material-ui/core/TextField';
import {
  getIn, useFormikContext,
} from 'formik';
import React, {
  useEffect,
} from 'react';
import FieldError from '../../Utils/FieldError';
import {
  FieldPropsCommon, TextAreaFieldValue,
} from '../types';
import {
  onChange,
} from '../utils';

type Props<T, K extends keyof T> = FieldPropsCommon<T, K> & TextAreaFieldValue<T, K>;

const TextAreaField = <FormModel, K extends keyof FormModel>(
  props: Props<FormModel, K>,
) => {
  const {
    values,
    handleChange,
    errors,
    touched,
    setFieldTouched,
    isSubmitting,
  } = useFormikContext<FormModel>();

  const {
    disabled,
    title,
    location,
  } = props;

  const value: string = getIn(values, location);
  const onValueChange = onChange(handleChange, location);
  const error = getIn(errors, location);
  const isTouched = getIn(touched, location);

  useEffect(() => {
    if (isSubmitting) {
      setFieldTouched(location);
    }
  }, [isSubmitting, location, setFieldTouched]);

  return (
    <>
      <TextField
        style={{
          margin: 8,
        }}
        value={value}
        variant="outlined"
        multiline
        disabled={disabled}
        onBlur={() => setFieldTouched(location)}
        onChange={(e) => {
          onValueChange(e.target.value);
        }}
        label={title}
      />
      <FieldError
        errors={error}
        touched={isTouched}
      />
    </>
  );
};

export default TextAreaField;
